<template>
    <div class="location-content-main">
    <div class="location-content">
        <div class="location-content-left">
            <transition name="fade" mode="out-in">
                <img loading="lazy"  :src="locationList[locationIndex].img" alt="" :key="locationIndex" @click="locationEvent(locationIndex,locationList)">
            </transition>
        </div>
        <div class="location-content-right">
            <div class="top">
                <transition name="fade" mode="out-in">
                    <div class="location-title" :key="locationIndex">
                        {{ locationList[locationIndex].title }}
                    </div>
                </transition>

                <transition name="fade" mode="out-in">
                    <div class="location-name" :key="locationIndex">
                        {{ locationList[locationIndex].name }}
                    </div>
                </transition>

                <transition name="fade" mode="out-in">
                    <div class="location-desc" :key="locationIndex">
                        {{ locationList[locationIndex].desc }}
                    </div>
                </transition>
            </div>
            <div class="bottom">
                <div class="bottom-left" @click="handleClick(1)">
                    <img loading="lazy"  :src="left" alt="">
                </div>
                <div class="bottom-num">{{ locationIndex + 1 }}/{{ locationList.length }}</div>
                <div class="bottom-right"  @click="handleClick(2)">
                    <img loading="lazy"  :src="right " alt="">
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import left from '/static/img/newProductDetils/left1.png'
import right from '/static/img/newProductDetils/right1.png'
export default{
    props:{
        locationList:Array
    },
    data(){
        return{
            locationIndex:0,
            left:left,
            right:right,
        }
    },
    methods:{
         handleClick(val){
            if(val == 1){
                if (this.locationIndex > 0) {
                    this.locationIndex--;
                }else if(this.locationIndex == 0){
                    this.locationIndex = this.locationList.length -1
                }
            }else if(val == 2){
                if (this.locationIndex < this.locationList.length -1) {
                    this.locationIndex++;
                }else if(this.locationIndex == this.locationList.length -1){
                    this.locationIndex = 0
                }
            }
        },
        locationEvent(index,list){
            this.$emit('childLocationEvent',index,list)
        }
    }

}
</script>
<style lang="scss">
    @import '/style/pc/newProductDetails/locationContent.scss';
    @import '/style/phone/newProductDetils/locationContent.scss';
</style>